// "Copy link" buttons: <button data-copy-link="/dashboard?sensor=12">. The
// path is on this site; the button says "Copied" for a moment, or shows the
// link to copy by hand when the browser won't let a page use the clipboard.
import htmlEntities from "../scripts/html-entities";
import { copyText } from "../scripts/url-state";

export const copyLinkButton = (path, label = 'Copy link') => `
  <button type="button" class="button button--small copy-link" data-copy-link="${htmlEntities(path)}"
    title="A link that opens this for anyone on your team who can see it">
    <i class="fas fa-link" aria-hidden="true"></i> <span class="copy-link__label">${htmlEntities(label)}</span>
  </button>`;

if (!window.__copyLinkReady) {
  window.__copyLinkReady = true;
  document.addEventListener('click', e => {
    const btn = e.target.closest && e.target.closest('[data-copy-link]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const path = btn.dataset.copyLink;
    const url = new URL(path.startsWith('/') ? window.site.home + path : path, window.location.href).href;
    const label = btn.querySelector('.copy-link__label') || btn;
    const was = label.dataset.was || label.textContent;
    label.dataset.was = was;
    copyText(url).then(ok => {
      if (ok) {
        label.textContent = 'Copied';
        clearTimeout(btn._copyTimer);
        btn._copyTimer = setTimeout(() => { label.textContent = was; }, 2000);
      } else {
        window.prompt('Copy this link:', url);
      }
    });
  }, true);
}
